export { translate } from './translate';
export { ITranslateProps } from './ITranslateProps';
